import * as React from "react";
import { DeckComponent } from "./DeckComponent";
import { ICard, ICardReference, CardSubType, IDeckBrowserFilter } from "./Card";
import { IDeck, NavigateDirection } from "./Deck";
import { CardUtil } from "./CardUtil";

interface IDeckBrowserState {
    selectedIndex: number;
}

export interface IDeckBrowserProps {
    deck: IDeck;
    filter: IDeckBrowserFilter;
    onBuyCard(cardReference: ICardReference): void;
}
export class DeckBrowserComponent extends React.Component<IDeckBrowserProps, IDeckBrowserState> {
    constructor(props: IDeckBrowserProps) {
        super(props);
        this.state = { selectedIndex: null };
    }
    navigate(direction: NavigateDirection): boolean {
        let cards = this.getAvailableCards();
        let selectedCard = cards[this.state.selectedIndex];
        if (direction === NavigateDirection.Enter) {
            this.props.onBuyCard(selectedCard);
            return true;
        }
        let diff = 0;
        switch (direction) {
            case NavigateDirection.Up:
            case NavigateDirection.Left:
                diff = -1;
                break;
            case NavigateDirection.Down:
            case NavigateDirection.Right:
                diff = 1;
                break;
            default: return false;
        }
        let index = this.state.selectedIndex + diff;
        if (index < 0) {
            index = cards.length - 1;
        }
        if (index >= cards.length) {
            index = 0;
        }
        this.setState({ selectedIndex: index });
        return true;
    }
    getAvailableCards() {
        let cards = this.props.deck.cards;

        cards = cards.filter(c => {
            if (c.set) return false;

            //hide unique cards
            if (c.unique) {
                const uc = this.props.filter.uniqueCards;
                if (uc && uc.length && uc.filter(n => n === c.name).length)
                    return false;
            }
            if (this.props.filter.hiddenCards.some((cr) => { return (CardUtil.equals(cr, c)); })) return false;
            switch (c.subType) {
                case CardSubType.Neutral: return this.props.filter.maxNeutralLevel >= c.xpCost;
                case CardSubType.Guardian: return this.props.filter.maxGuardianLevel >= c.xpCost;
                case CardSubType.Seeker: return this.props.filter.maxSeekerLevel >= c.xpCost;
                case CardSubType.Rouge: return this.props.filter.maxRougeLevel >= c.xpCost;
                case CardSubType.Mystic: return this.props.filter.maxMysticLevel >= c.xpCost;
                case CardSubType.Survivor: return this.props.filter.maxSurvivorLevel >= c.xpCost;

                default:
                    return false;
            }
        });
        return cards;
    }
    render() {
        const cards = this.getAvailableCards();
        let selectedCard:ICard = null;
        let selectedIndex=this.state.selectedIndex;
        if(cards && cards.length) {
            if(!selectedIndex || selectedIndex<0){
                selectedIndex=0;
            } else if(selectedIndex>=cards.length){
                selectedIndex=cards.length-1;
            }
            selectedCard=cards[selectedIndex]
        } else {
            selectedIndex=null;
        }

        const selectedDeck: IDeck = { cards: [] };
        if (selectedCard)
            selectedDeck.cards.push(selectedCard);
        const cardRows = cards.map((c,i) => {
            if (!selectedCard) selectedCard = c;
            let classNames = null;
            if (c === selectedCard) {
                classNames = "active";
            }
            return (<tr key={c.pack + ":" + c.packNumber} className={classNames} onClick={() => this.setSelectedCard(i)}>
                <td><i title={CardSubType[c.subType]} className={CardUtil.getSubTypeSymbol(c.subType)}></i></td>
                <td>{c.name} {c.unique ? "*" : ""}</td>
                <td>{c.xpCost}</td>
                <td><a className="buy-card" title="Buy card" onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.props.onBuyCard(c);
                    return false;
                }}><i className="glyphicon glyphicon-plus"></i></a></td></tr>);
        });
        if (selectedIndex !== this.state.selectedIndex) {
            setTimeout(() => { this.setSelectedCard(selectedIndex); });
        }
        return (
            <div className="deck-browser">
                <div className="row">
                    <div className="col col-md-6">
                        <table>
                            <thead>
                                <tr><th>Type</th><th>Name</th><th>Level</th><th></th></tr>
                            </thead>
                            <tbody>
                                {cardRows}
                            </tbody>
                        </table>
                    </div>
                    <div className="col col-md-6">
                        <DeckComponent deck={selectedDeck} settings={
                            {
                                toolbar: {
                                    flip: false,
                                    navigate: (d) => { return this.navigate(d); }
                                }
                            }} />
                    </div>
                </div>
            </div>
        );
    }

    setSelectedCard(index: number) {
        this.setState({ selectedIndex: index });
    }
}
